import {Component, OnInit} from '@angular/core';

import {Site, SiteService} from '../common/services';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {PubSubService} from '../common/services/pub-sub.service';
import {BdcService} from '../bdc.service';


@Component({
  selector: 'p8-bdc-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {
  site: Site;
  sites$: Observable<Site[]>;

  constructor(
    private siteService: SiteService,
    private bdcService: BdcService,
    private pubSubSvc: PubSubService,
  ) {
  }

  ngOnInit() {
    this.loadSites();
  }

  loadSites() {
    this.pubSubSvc.publish('loading', true);
    this.sites$ = this.siteService
      .list(0, 0, '')
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false))
      );
  }
}
